<template>
  <pt-gene-lab-order class="pt-gene-lab-order__withData" :detection-package-list="detectionPackageList" :areaList="areaList" :seqTypes="seqTypes" v-bind="$attrs" v-on="$listeners"></pt-gene-lab-order>
</template>

<script>
import PtGeneLabOrder from './index'
export default {
  name: 'pt-gene-lab-order__withData',
  components: {
    'pt-gene-lab-order': PtGeneLabOrder
  },
  data () {
    return {
      areaList: [],
      organizationType: ['DISTRIBUTION', 'AGENT'],
      seqTypes: []
    }
  },
  methods: {
    getDetectionPackageList () {
      let data = {
        page: 0,
        size: 99999,
        sort: 'id,desc'
      }
      this.$store.dispatch('getPackages', data)
    },
    getAreatList () {
      this.$store.dispatch('getBusinessArea').then(data => {
        let options = []
        data.forEach(item => {
          let signalItem = {
            label: item.name,
            value: item.value
          }
          options.push(signalItem)
        })
        this.areaList = options
      })
    },
    getSeqTypes () {
      let data = {
        example: { organizationRole: 'LAB' },
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,desc'] }
      }
      this.$store.dispatch('labTestPlatformList', data).then(res => {
        this.seqTypes = res.data.map(e => {
          return {
            value: e.name,
            label: e.name
          }
        })
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  computed: {
    detectionPackageList () {
      return this.$store.state.detectionPackageList
    }
  },
  created () {
    this.getDetectionPackageList()
    this.getAreatList()
    this.getSeqTypes()
  }
}
</script>
